import { lazy } from "react"
import { Route } from "react-router"
import RequireRoutePermit from "RequireRoutePermit"

const CreateEditRent = lazy(() => import("./admin/CreateEditRent"))
const Rents = lazy(() => import("./admin/Rents"))
const AdminEmployeeRents = lazy(() => import("./admin/EmployeeRents"))

// EMPLOYEE
const EmployeeRents = lazy(() => import("./employee/EmployeeRents"))
const CreateEditRentEmployee = lazy(() => import("./employee/CreateEditRent"))

const rentsRoutes = (
  <>
    <Route
      path="rents"
      element={
        <RequireRoutePermit allowedPermissions={["can_view_document_requests"]}>
          <Rents />
        </RequireRoutePermit>
      }
    />
    <Route
      path="rents/create"
      element={
        <RequireRoutePermit
          allowedPermissions={["can_create_document_requests"]}
        >
          <CreateEditRent />
        </RequireRoutePermit>
      }
    />
    <Route
      path="rents/edit"
      element={
        <RequireRoutePermit
          allowedPermissions={["can_update_document_requests"]}
        >
          <CreateEditRent />
        </RequireRoutePermit>
      }
    />
    <Route
      path="rents/employee"
      element={
        <RequireRoutePermit allowedPermissions={["can_view_document_requests"]}>
          <AdminEmployeeRents />
        </RequireRoutePermit>
      }
    />
  </>
)

export const rentsEmployeeRoutes = (
  <>
    <Route
      path="rents"
      element={<EmployeeRents />}
    />
    <Route
      path="rents/create"
      element={<CreateEditRentEmployee />}
    />
    <Route
      path="rents/edit"
      element={<CreateEditRentEmployee />}
    />
  </>
)

export default rentsRoutes
